import { alpha, Paper, styled } from '@mui/material';
import { MdSource } from 'react-icons/md';

export const InputCheckboxStyled = styled('div')({
  margin: '16px 0 32px 0',
  '@media(min-width: 751px)': {
    display: 'none',
  },
});

export const SwitchStyled = styled('input')(({ theme }) => ({
  '&:before': {
    backgroundColor: theme.palette.secondary.main,
  },
  ':checked::before': {
    backgroundColor: theme.palette.secondary.main,
  },
}));

export const RootStyled = styled('div')(({ theme }) => ({
  padding: theme.spacing(8),
  margin: '0 auto',
  '@media (max-width: 750px)': {
    padding: 32,
    '& h2': {
      fontSize: 22,
      marginTop: 16,
      marginBottom: -16,
    },
  },
}));

export const PaperStyled = styled(Paper)({
  padding: 24,
  width: '100%',
  '@media (max-width: 750px)': {
    display: 'none',
  },
});

export const NoContentStyled = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '16px',
});

export const IconStyled = styled(MdSource)(({ theme }) => ({
  color: alpha(theme.palette.global.lightgray, 0.5),
  fontSize: 150,
}));
